// shared-components/features/auth/ProtectedRoute.jsx

import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@shared/hooks";
import { useWebsite } from "@shared/hooks";
import { useState, useEffect } from "react";
import { authService } from "@shared/services";

export const ProtectedRoute = ({ children, checkWebsiteAccess = true }) => {
  const { user, isAuthenticated, loading } = useAuth();
  const { websiteId } = useWebsite();
  const location = useLocation();
  const [hasAccess, setHasAccess] = useState(false);
  const [checkingAccess, setCheckingAccess] = useState(checkWebsiteAccess);

  useEffect(() => {
    const checkAccess = async () => {
      //console.log("Auth state:", { isAuthenticated, user, loading, websiteId });

      if (isAuthenticated && user && checkWebsiteAccess) {
        //console.log("Checking website access for user:", user.id);
        const access = await authService.verifyWebsiteAccess(
          user.id,
          websiteId,
        );
        //console.log("Access result:", access);
        setHasAccess(access);
      } else if (isAuthenticated && !checkWebsiteAccess) {
        // If we're not checking website access, grant access by default
        setHasAccess(true);
      }
      setCheckingAccess(false);
    };

    if (!loading) {
      checkAccess();
    }
  }, [isAuthenticated, loading, user, websiteId, checkWebsiteAccess]);

  if (loading || checkingAccess) {
    return <div>Loading...</div>; // Replace with your loading component
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  if (checkWebsiteAccess && !hasAccess) {
    // User is authenticated but doesn't have access to this website
    return <Navigate to="/admin/unauthorized" replace />;
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  checkWebsiteAccess: PropTypes.bool,
};
